import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsTab   from 'contents_tab';

import Post          from '@common/post/_post';
// -------------------------------------------------------

class InfluencerPosts extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      tab: Utils.getLocalData({ id: 'common/influencer/post_tab', default: 'feed' }),
    };
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  tabSelect(tab) {
    this.setState({ tab: tab });
    Utils.saveLocalData({ id: 'common/influencer/post_tab', data: tab });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let tab  = this.state.tab;
    
    if( this.props.ng_html != null ) return this.props.ng_html;
    if( data.posts == null ) return null;

    let feed_posts  = [];
    let reel_posts  = [];
    let story_posts = data.stories || [];

    data.posts.map((d) => { if( d.product_type == 'FEED' ) feed_posts.push(d); });
    data.posts.map((d) => { if( d.product_type == 'REELS' ) reel_posts.push(d); });
    
    // タブリスト
    let tabs = [
      { id: 'feed',   name: 'フィード ('+ feed_posts.length +')',    html: <InfluencerPostsList tab="feed" posts={feed_posts} /> },
      { id: 'reel',   name: 'リール ('+ reel_posts.length +')',      html: <InfluencerPostsList tab="reel" posts={reel_posts} /> },
      { id: 'story',  name: 'ストーリー ('+ story_posts.length +')', html: <InfluencerPostsList tab="story" posts={story_posts} /> },
    ];
    
    return (
      <div className="influencer-posts">
        <ContentsTab tabs={tabs} select={this.state.tab} font_size={11} className="button-contents-tab" update_ev={this.tabSelect.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

class InfluencerPostsList extends React.Component {
  render() {
    let posts = this.props.posts;
    if( posts.length == 0 ){
      return <div className="influencer-posts-contents"><p className="post-none">投稿がありません</p></div>;
    }
    
    return (
      <div className="influencer-posts-contents">
        
        <Summary posts={posts} tab={this.props.tab} />
        
        <div className="posts-list">
          { posts.map((d, key) => {
            if( d.thumbnail == null ) return null;
            return <Post key={key} data={d} />
          })}
        </div>
        
      </div>
    );
  }
}
// -------------------------------------------------------

class Summary extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      mode: Utils.getLocalData({ id: 'common/influencer/post_mode', default: 'recent_9' }),
    };
  }
  // -------------------------------------------------------
  
  changeMode() {
    this.setState({ mode: this.mode.value });
    Utils.saveLocalData({ id: 'common/influencer/post_mode', data: this.mode.value });
  }
  // -------------------------------------------------------
  
  render() {
    let posts = this.props.posts;
    let tab = this.props.tab;
    
    // 集計方法
    let select_mode = [
      { id: 'recent_9',  name: '直近9投稿' },
      { id: 'recent_30', name: '直近30投稿' },
      { id: 'month_1',   name: '直近1ヶ月' },
      { id: 'month_3',   name: '直近3ヶ月' },
      { id: 'all',       name: '全期間' },
    ]
    
    // サマリーリスト
    let summary = {
      feed: [
        { id: 'likes',          name: '平均いいね数',   fmt: 'int', value: 0, count: 0 },
        { id: 'comments',       name: '平均コメント数', fmt: 'int', value: 0, count: 0 },
        { id: 'engagement_per', name: '平均ENG率',      fmt: 'per', value: 0, count: 0 },
      ],
      reel: [
        { id: 'likes',     name: '平均いいね数',   fmt: 'int', value: 0, count: 0 },
        { id: 'comments',  name: '平均コメント数', fmt: 'int', value: 0, count: 0 },
        { id: 'plays',     name: '平均再生数',     fmt: 'int', value: 0, count: 0 },
        { id: 'plays_per', name: '平均再生率',     fmt: 'per', value: 0, count: 0 },
      ],
      story: []
    };
    
    // 対象投稿
    posts.map((d, key) => {
      let diff = Moment().diff( Moment(d.post_date), 'month');
      
      if( this.state.mode == 'recent_9'  && key >= 9  ) return; // 直近9投稿
      if( this.state.mode == 'recent_30' && key >= 30 ) return; // 直近30投稿
      if( this.state.mode == 'month_1'   && diff >= 1 ) return; // 直近1ヶ月
      if( this.state.mode == 'month_3'   && diff >= 3 ) return; // 直近3ヶ月
      
      summary[tab] = summary[tab].map((s) => {
        if( d[s.id] != null ){
          s.value += d[s.id];
          s.count += 1;
        }
        
        return s;
      });
    });
    
    return (
      <div className="influencer-posts-summary">
        
        <div className="mode-select">
          <h6>集計方法</h6>
          <div className="selectbox">
            <select ref={(input) => { this.mode = input }} onChange={this.changeMode.bind(this)} defaultValue={this.state.mode}>
              { select_mode.map((d, key) => {
                return <option key={key} value={d.id}>{d.name}</option>;
              })}
            </select>
          </div>
        </div>
        <ul>
          { summary[tab].map((d, key) => {
            return (
              <li key={key}>
                <h5>{d.name}</h5>
                <h2>{Utils.viewInt((d.value / d.count))}{(d.fmt == 'per') && '%'}</h2>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerPosts;